import styled from 'styled-components';

type UserAvatarStyledProps = {
  pointer: boolean;
};
export const UserAvatarStyled = styled.div<UserAvatarStyledProps>`
  cursor: ${({ pointer }): string => (pointer ? 'pointer' : 'default')};
`;
